module.exports = __webpack_public_path__ + "img/24.068aef07.png";